<template>
    <div class="activityManage">

        <div class="breadcrumb">活动管理
            <el-button class="right_f" type="primary" @click="newActivity">新增</el-button>
        </div>

        <div class="activity">
            <el-select v-model="activityStatus" @change="neirong">
                <el-option label="全部状态" value='-1'></el-option>
                <el-option label="草稿" value='1'></el-option>
                <el-option label="已发布" value='4'></el-option>
                <el-option label="已撤销" value='9'></el-option>
                <el-option label="热门" value='7'></el-option>
            </el-select>
            <el-select v-model="unid" filterable clearable placeholder="请选择" @change="neirong">
                <el-option v-for="item in options" :value="item.unid" :label="item.name" :key="item.unid">
                </el-option>
            </el-select>

        </div>

        <div class="com-list">

            <el-table :data="activitys" style="overflow-x: auto;">

                <el-table-column prop="index" label="序号" align='center' width="80">
                </el-table-column>
                <el-table-column prop="activityId" label="活动ID" align='center' width="80">
                </el-table-column>
                <el-table-column show-overflow-tooltip label="活动图片" align='center' width="150" inline-template>
                    <img :src="row.bigImageUrl">
                </el-table-column>
                <el-table-column prop="name" label="活动名称" align='center' width="150">
                </el-table-column>
                <el-table-column prop="activityType" label="活动类型" align='center' width="180">
                </el-table-column>

                <el-table-column prop="qizhiDate" label="起止日期" align='center' width="200">
                </el-table-column>
                <el-table-column prop="status" label="状态" align='center' width="100">
                </el-table-column>
                <el-table-column label="操作时间" align='center' width="150" inline-template>
                    <div>
                        <div>{{row.updateName}}</div>
                        <div>{{row.updateTime}}</div>
                    </div>
                </el-table-column>
                <el-table-column label="创建时间" align='center' width="200" inline-template>
                    <div>
                        <div>{{row.createName}}</div>
                        <div>{{row.createTime}}</div>
                    </div>
                </el-table-column>
                <el-table-column inline-template label="操作" width="120">
                    <div class="btn-box">
                        <el-button class="option" type="text" @click="showDetail(row.activityId)">详情</el-button>
                        <el-button class="option" type="text" v-if="row.status == '草稿' || row.status =='已撤销' "
                            @click="editNew(row.activityId)">修改</el-button>
                        <el-button class="option" type="text" v-if="row.status == '草稿' || row.status =='已撤销'"
                            @click="updateStatus(row,0)">发布</el-button>
                        <el-button class="option" type="text" v-if="row.status == '已发布'" @click="beHit(row,1)">上热门
                        </el-button>
                        <el-button class="option" type="text" v-if="row.status == '已发布'" @click="updateStatus(row,1)">
                            撤销发布</el-button>
                        <el-button class="option" type="text" v-if="row.status == '热门'" @click="beHit(row,0)">取消热门
                        </el-button>
                        <el-button class="option" type="text" @click="toPrize(row.activityId)">奖品管理</el-button>
                        <el-button class="option" type="text" @click="clickPrizeDetail(row)">奖励明细</el-button>
                        <el-button class="option" type="text" v-if="row.status == '草稿' || row.status =='已撤销'"
                            @click="deleteactivity(row)">删除</el-button>
                    </div>
                </el-table-column>

            </el-table>
        </div>
        <div class="pagination">
            <el-pagination v-show="this.totalCount > 0" layout="prev, pager, next, jumper" :page-size="20"
                :current-page="currentPage" :total="totalCount" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <el-dialog v-if="prizeDialog.visible" v-model="prizeDialog.visible" title="奖励明细导出" width="50%" :modal-append-to-body="false" :destroy-on-close="true">
            <el-form>
                <el-form-item label="获取时间">
                    <el-date-picker
                        v-model="prizeDialog.startDate"
                        format="yyyy/MM/dd"
                        placeholder="开始日期"
                        style="width: 300px"
                        :picker-options="pickerOptions"
                        :default-value="pickerStartDefault"
                    ></el-date-picker>
                    至      
                    <el-date-picker
                        v-model="prizeDialog.endDate"
                        format="yyyy/MM/dd"
                        placeholder="结束日期"
                        style="width: 300px"
                        :picker-options="pickerOptions"
                        :default-value="pickerEndDefault"
                    ></el-date-picker>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="prizeDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="clickDoneExport">确认并导出</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activityStatus: '-1',
                currentPage: 1,
                totalCount: 0,
                options: [],
                unid: '',
                activitys: [],
                prizeDialog: {
                    visible: false,
                    row: {},
                    startDate: '',
                    endDate: '',
                },
                prizeDate: ''
            }
        },
        computed: {
            pickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        const daterange = _this.prizeDialog.row.qizhiDate.split('-');
                        const startDate = new Date(daterange[0].trim());
                        const endDate = new Date(daterange[1].trim());
                        return time.getTime() < startDate.getTime() || time.getTime() > endDate.getTime();
                    },
                }
            },
            pickerStartDefault() {
                if (this.prizeDialog.row.qizhiDate) {
                    return this.prizeDialog.row.qizhiDate.split('-')[0].trim();
                } else {
                    return Date.now();
                }
            },
            pickerEndDefault() {
                if (this.prizeDialog.row.qizhiDate) {
                    return this.prizeDialog.row.qizhiDate.split('-')[1].trim();
                } else {
                    return Date.now();
                }
            }
        },
        mounted() {
            //请求获取activitys数据
            this.paramAndGet();
            this.getschoolandunid();
        },
        methods: {
            paramAndGet() {
                let url = window.location.href;

                if (url.indexOf('?') !== -1) {
                    this.activityStatus = this.$util.getUrlParam('status');
                    this.getActivitys(this.activityStatus, this.unid);
                } else {
                    this.getActivitys(this.activityStatus, this.unid);
                }
            },
            newActivity() {
                location.href = "#/yunying/activity/newActivity";
            },
            neirong() {
                location.href = `/#/yunying/activity/activityManage?status=${this.activityStatus}&unid=${this.unid}`;
                this.paramAndGet();
            },
            /***
             * 获取活动列表
             ***/
            getActivitys(status, unid) {
                this.status = status || -1;
                //this.unid = unid || -1;
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v1/operate/activity/list',
                    body: JSON.stringify({
                        status: status * 1,
                        pageNum: this.currentPage,
                        unid: this.unid?this.unid*1:-1,
                        pageSize: 20
                    })
                }).then((response) => {
                    if (response.data.error === 10000) {
                        let dataList = response.data.data.list;
                        //处理获取到的activity列表数据
                        this.activitys = [];
                        this.totalCount = response.data.data.totalCount;
                        for (let i = 0; i < dataList.length; i++) {
                            let name = dataList[i].name,
                                index = i + 1,
                                status = dataList[i].activityStatus,
                                activityId = dataList[i].activityId,
                                activityType = dataList[i].activityType + '',
                                bigImageUrl = dataList[i].bigImageUrl,
                                updateTime = new Date(dataList[i].updateTime),
                                updateName = dataList[i].updateName,
                                createName = dataList[i].createName,
                                createTime = new Date(dataList[i].createTime),
                                startTime = new Date(dataList[i].startTime),
                                endTime = new Date(dataList[i].endTime);
                            switch (activityType) {
                                case "1":
                                    activityType = "跑步奖励"
                                    break;
                                case "2":
                                    activityType = "其他活动"
                                    break;
                                case "3":
                                    activityType = "室内锻炼"
                                    break;
                            }

                            switch (status) {
                                case 7:
                                    status = '热门';
                                    break;
                                case 1:
                                    status = '草稿';
                                    break;
                                case 4:
                                    status = '已发布';
                                    break;
                                case 9:
                                    status = '已撤销';
                                    break;
                            };
                            this.activitys.push({
                                name: name,
                                index: index,
                                status: status,
                                activityId: activityId,
                                activityType: activityType,
                                bigImageUrl: bigImageUrl,
                                updateName: updateName,
                                updateTime: updateTime.format("yyyy/MM/dd hh:mm"),
                                createName: createName,
                                createTime: createTime.format("yyyy/MM/dd hh:mm"),
                                qizhiDate: startTime.format("yyyy/MM/dd") + "  -  " + endTime.format("yyyy/MM/dd")
                            })

                        }
                    }
                })
            },
            showDetail(id) {
                location.href = "#/yunying/activity/activityDetail?activityId=" + id;
            },
            editNew(id) {
                location.href = "#/yunying/activity/newActivity?activityId=" + id;
            },
            updateStatus(row, status) {
                if (status == "1") {
                    this.$confirm('你确定要撤销活动“ ' + row.name + " ”吗？", '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.change_status(row, 9);
                    })
                } else {
                    this.$confirm('你确定要发布活动“' + row.name + "”吗？", '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.change_status(row, 4);
                    })

                }

            },
            /**
             *上热门和取消热门的方法
             0代表取消热门，1代表上热门； 
             **/
            beHit(row, beHit) {
                if (beHit == '0') {
                    //取消热门,状态变为已发布，
                    this.$confirm('你确定要将活动“' + row.name + "”取消热门吗？", '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.change_status(row, 4);
                    })
                } else {
                    //上热门
                    this.$confirm('你确定要将活动“' + row.name + "”上热门吗？", '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.change_status(row, 7);
                    })

                }
            },
            change_status(row, status) {
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v2/operate/activity/updateStatus',
                    body: JSON.stringify({
                        activityId: row.activityId,
                        activityStatus: status
                    })
                }).then(response => {
                    if (response.data.error === 10000) {
                        window.location.reload();
                    }
                })
            },
            deleteactivity(row) {
                this.$confirm('你确定要删除活动“' + row.name + "”吗？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        method: 'POST',
                        url: this.$util.domain + '/adminapi/v1/operate/activity/delete',
                        body: JSON.stringify({
                            activityId: row.activityId,
                        })
                    }).then(response => {
                        if (response.data.error === 10000) {
                            window.location.reload();
                        }
                    })
                })
            },
            /**
            *活动奖励的入口*
            **/
            toPrize(id) {
                location.href = "#/yunying/activity/prizeManage?activityId=" + id + "&online=-1";
            },
            // 点击奖励明细
            clickPrizeDetail(row) {
                this.prizeDialog.row = row
                this.prizeDialog.startDate = ''
                this.prizeDialog.endDate = ''
                this.prizeDialog.visible = true
            },
            // 点击确认并导出奖励明细
            clickDoneExport() {
                if (!this.prizeDialog.startDate || !this.prizeDialog.endDate) {
                    this.$util.errorMsg('请选择日期');
                    return;
                }
                if (this.prizeDialog.startDate > this.prizeDialog.endDate) {
                    this.$util.errorMsg('开始日期不能大于结束日期');
                    return;
                }
                const url = this.$util.domain + '/adminapi/v2/operate/prize/export'
                    + '?activityId=' + this.prizeDialog.row.activityId
                    + '&beginTime=' 
                    + this.$util.dateFormat(this.prizeDialog.startDate, 'yyyy-MM-dd') + ' 00:00:00'
                    + '&endTime=' 
                    + this.$util.dateFormat(this.prizeDialog.endDate, 'yyyy-MM-dd') + ' 23:59:59';
                location.href = url;
                this.prizeDialog.visible = false;
            },
            //请求分页数据*
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getActivitys(this.activityStatus, this.unid);
            },

            //***获取所有校区信息,用于在下拉框选项中展示**//
            getschoolandunid() {
                this.$http({
                    method: 'get',
                    url: this.$util.domain + '/adminapi/v1/basicTools/allCampusZones'
                }).then((response) => {
                    this.options = response.body.data;//给option数组赋值，这里要在下拉列表里面展示出来
                })
            },
        }
    }
</script>
<style>
    .activityManage .el-select {
        display: inline-block;
    }

    .activityManage img {
        display: block;
        width: 70%;
        height: 80%;
        margin: 10px;
    }

    .activityManage .btn-box {
        padding-top: 5px;
    }

    .activityManage .btn-box .el-button {
        width: 70px;
        padding: 5px;
        border: solid 1px #999;
    }

    .activityManage .el-input {
        display: inline-block;
    }

    .activityManage .el-button {
        display: inline-block;
    }

    .activityManage .el-button+.el-button {
        margin-left: 0;
    }

    .activityManage .option {
        margin-bottom: 5px;
    }

    .activity {
        margin-left: 20px;
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// activityManage.vue?3bed7c8c